//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from "../../layouts/Header.vue";
import Footer from "../../layouts/Footer.vue";
import CtaBanner from "../../components/CtaBanner.vue";
import HeroPageBanner from "../../components/HeroPageBanner.vue";
import Accordion from "./../../components/Accordion";
import AccordionItem from "./../../components/AccordionItem";

export default {
  name: "patient-member-portal",
  components: {
    Header,
    Footer,
    CtaBanner,
    HeroPageBanner,
    Accordion,
    AccordionItem,
  },
  data() {
    return {
      features: [
        {
          id: 1,
          title: "Symptom Search",
          text: "Get health recommendations by following easy steps such as providing symptoms and answering a few questions.",
          imageSrc: "/images/symptom-search.png",
          imageSrc2: "/images/symptom-search-question.png",
          imageSrctext: "Select symptoms",
          imageSrc2text: "Answer a few questions",
          imageSrc3: "",
          imageSrc3text: "",
          show: false,
          hasImages: true,
        },
        {
          id: 2,
          title: "Offline Consultation ",
          text: "Find the right doctor in your area for your medical needs and make an appointment using a few easy steps.",
          imageSrc: "/images/offline-consultation.png",
          imageSrc2: "",
          imageSrctext: "Make an offline appointment",
          imageSrc2text: "",
          imageSrc3: "",
          imageSrc3text: "",
          show: false,
          hasImages: true,
        },
        {
          id: 3,
          title: "Online Consultation",
          text: "Use video calling to talk to a doctor instantly or book an online consultation for later.",
          imageSrc: "/images/online-consultation.png",
          imageSrc2: "",
          imageSrctext: "Consult online",
          imageSrc2text: "",
          imageSrc3: "",
          imageSrc3text: "",
          show: false,
          hasImages: true,
        },
        {
          id: 4,
          title: "Buy Medicine",
          text: "Search for medicines, order them online and get them delivered right to your home.",
          imageSrc: "/images/buy-medicine.png",
          imageSrc2: "",
          imageSrctext: "Order medicine",
          imageSrc2text: "",
          imageSrc3: "",
          imageSrc3text: "",
          show: false,
          hasImages: true,
        },
        {
          id: 5,
          title: "Insurance",
          text: "Have insurance services like making and managing claims, checking coverages and more at your convenience.",
          imageSrc: "/images/insurance.png",
          imageSrc2: "",
          imageSrctext: "Manage insurance",
          imageSrc2text: "",
          imageSrc3: "",
          imageSrc3text: "",
          show: false,
          hasImages: true,
        },
        {
          id: 6,
          title: "Medical services",
          text: "Avail health services like laboratory tests, medical checkups, immunization, vaccination, and much more.",
          imageSrc: "/images/medical-services.png",
          imageSrc2: "",
          imageSrctext: "Health services",
          imageSrc2text: "",
          imageSrc3: "",
          imageSrc3text: "",
          show: false,
          hasImages: true,
        },
        {
          id: 7,
          title: "Healthcare Providers",
          text: "Find healthcare providers near you and book medical services with them.",
          imageSrc: "/images/healthcare-providers.png",
          imageSrc2: "",
          imageSrctext: "Healthcare providers",
          imageSrc2text: "",
          imageSrc3: "",
          imageSrc3text: "",
          show: false,
          hasImages: true,
        },
        {
          id: 8,
          title: "Online Prescription",
          text: "Get prescription online instantly after consultation and use it to purchase medicine.",
          imageSrc: "",
          imageSrc2: "",
          imageSrctext: "",
          imageSrc2text: "",
          imageSrc3: "",
          imageSrc3text: "",
          show: false,
          hasImages: false,
        },
      ],
    };
  },
  methods: {
    getIndex(id) {
      const item = this.features.findIndex((data) => data.id === id);
      this.features[item].show = !this.features[item].show;
    },
  },
  head: {
    title: "Patient/Member Portal | Mazecare",
    meta: [
      {
        hid: "description",
        name: "description",
        content:
          "Complete integrated solution for patients. Get healthcare services at your fingertips. Manage insurance and make claims easily.",
      },
      {
        name: "keywords",
        content:
          "healthcare service, medical services, patient solution, patient management system, insurance management system",
      },
    ],
  },
};
